var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-home"},_vm._l((_vm.permissibleLinks),function(route,index){return _c('ButtonNavLink',{key:("" + (route.meta.title) + index),attrs:{"route":route}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }